export class ArtrackWaypointMedia {
    url?: string | null;
    thumbnailUrl?: string | null;
    type?: string | null;

    constructor(init?: Partial<ArtrackWaypointMedia>) {
        Object.assign(this, init);
    }
}

export class ArtrackWaypointMeta {
    index: number;
    lat?: number;
    lon?: number;
    alt?: number;
    time?: string;
    speed?: number;
    media?: ArtrackWaypointMedia[];

    constructor(index: number, init?: Partial<ArtrackWaypointMeta>) {
        this.index = index;
        Object.assign(this, init);
    }
}

export class ArtrackTrackMeta {
    trackId: number;
    utmZone?: string; // e.g., "33T"
    hemisphere?: 'N' | 'S';
    originEasting?: number;
    originNorthing?: number;

    constructor(trackId: number, init?: Partial<ArtrackTrackMeta>) {
        this.trackId = trackId;
        Object.assign(this, init);
    }
}

